import { IState } from 'legacy/lut/store'

export const selectPartnerSearchState = (state: IState) => state.partnerSearch
